import { Button, Dialog, DialogContent, Typography } from "@mui/material";
import styles from "./TrialStatus.module.scss";

const TITLE_ID = "trial-ends-today-title";
const DESCRIPTION_ID = "trial-ends-today-description";

const TrialEndsTodayModal = ({ open, onClose, onUpgrade }) => (
  <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby={TITLE_ID}
    aria-describedby={DESCRIPTION_ID}
    PaperProps={{ className: styles.modalPaper }}
  >
    <DialogContent className={styles.modalContent}>
      <Typography id={TITLE_ID} component="h2" className={styles.modalTitle}>
        Your trial ends today
      </Typography>
      <Typography id={DESCRIPTION_ID} className={styles.modalCopy}>
        Upgrade now to keep your lists and premium features without
        interruption.
      </Typography>
      <div className={styles.modalActions}>
        <Button
          variant="outlined"
          className={styles.secondaryButton}
          onClick={onClose}
        >
          Maybe later
        </Button>
        <Button
          variant="contained"
          disableElevation
          className={styles.primaryButton}
          onClick={onUpgrade}
        >
          Upgrade now
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);

export default TrialEndsTodayModal;
